// EGMG Managed Transportation pricing (rates valid until 31.12.2026).
// All listed rates are NET in AED; 5% VAT is added on top of every charge.

export const VAT_RATE = 0.05;

// Returns { base, vat, total } with 5% VAT added on top of a net amount.
export const fareVAT = (net) => {
  const base = Math.round(net);
  const vat = Math.round(base * VAT_RATE);
  return { base, vat, total: base + vat };
};

export const money = (n) => `AED ${Math.round(n).toLocaleString()}`;

// ─────────────────────────── AIRPORT TRANSFERS (App II / III / IV) ───────────────────────────
// Vehicle columns are shared across airports, in this fixed order.
export const TRANSFER_VEHICLES = [
  { id: 'exec-sedan', name: 'Executive Sedan', models: 'Lexus ES / BMW 5 / Tesla Model 3', pax: '3 passengers · 2 bags' },
  { id: 'compact-suv', name: 'Compact SUV', models: 'Tesla Model Y', pax: '4 passengers · 3 bags' },
  { id: 'luxury-suv', name: 'Luxury SUV (7-Seat)', models: 'GMC Yukon XL', pax: '6 passengers · 5 bags', badge: 'Airport & Groups' },
  { id: 'exec-van', name: 'Executive Van (7-Seat)', models: 'Mercedes Viano', pax: '7 passengers · 7 bags' },
  { id: 'first-sedan', name: 'First Class Sedan', models: 'BMW 7 Series / Mercedes S-Class', pax: '3 passengers · 2 bags', badge: 'VIP' },
];

export const AIRPORTS = [
  {
    id: 'DXB', name: 'Dubai International Airport (DXB)',
    zones: [
      { id: 'dxb-z1', name: 'Zone 1', areas: 'Deira, Mirdif, Bur Dubai, Satwa, Al Qusais, Umm Ramool, Al Rashidiya, Festival City', prices: [140, 190, 230, 250, 350] },
      { id: 'dxb-z2', name: 'Zone 2', areas: 'Karama, Oud Metha, Al Jaddaf, Healthcare City, Jumeirah 1, DIFC, Downtown, Business Bay, Dubai Mall', prices: [170, 220, 260, 290, 400] },
      { id: 'dxb-z3', name: 'Zone 3', areas: 'Jumeirah 2/3, Umm Suqeim, Al Barsha, JLT, Internet City, Media City, Mall of the Emirates, Silicon Oasis, Academic City, JBR, Burj Al Arab', prices: [190, 250, 290, 320, 450] },
      { id: 'dxb-z4', name: 'Zone 4', areas: 'Dubai Marina, Jumeirah Islands, Emirates Hills, Meadows, JLT, Palm Jumeirah, Arabian Ranches, Sports City, Motor City, Discovery Gardens, Global Village, The Villa', prices: [220, 290, 350, 390, 490] },
      { id: 'dxb-z5', name: 'Zone 5', areas: 'Jebel Ali Hotel, Dubai Parks & Resorts, Al Maktoum Airport, JAFZA, DIP', prices: [260, 330, 390, 440, 550] },
      { id: 'dxb-z6', name: 'Zone 6', areas: 'Sharjah City, Bab Al Shams, Al Maha Resort, Ajman', prices: [290, 360, 440, 480, 600] },
      { id: 'dxb-z7', name: 'Zone 7', areas: 'Abu Dhabi City, Al Ain, Fujairah, Ras Al Khaimah, Khorfakkan, Umm Al Quwain', prices: [450, 520, 600, 660, 790] },
    ],
  },
  {
    id: 'DWC', name: 'Al Maktoum International Airport (DWC)',
    zones: [
      { id: 'dwc-z1', name: 'Zone 1', areas: 'Jebel Ali Industrial, Dubai Industrial City, Dubai Investment Park 1 & 2, Techno Park, Jebel Ali Hotel, JAFZA, Dubai Parks & Resorts', prices: [170, 220, 280, 320, 400] },
      { id: 'dwc-z2', name: 'Zone 2', areas: 'The Gardens, Discovery Gardens, Al Furjan, Jumeirah Park, Jumeirah Islands, The Springs, The Meadows, Emirates Hills, Sports City, Motor City, Studio City, JLT, Expo City', prices: [210, 260, 340, 380, 450] },
      { id: 'dwc-z3', name: 'Zone 3', areas: 'Arabian Ranches, JVC, Al Barsha, The Greens, Media City, Al Sufouh, Internet City, Knowledge City, Dubai Marina, JBR', prices: [240, 290, 390, 430, 490] },
      { id: 'dwc-z4', name: 'Zone 4', areas: 'Palm Jumeirah, Al Quoz, Umm Suqeim, Jumeirah, Al Barari, City of Arabia, The Villa, Legoland, Majan, Falcon City, Downtown, Business Bay, Silicon Oasis, DXB Airport', prices: [260, 330, 390, 440, 540] },
      { id: 'dwc-z5', name: 'Zone 5', areas: 'Bur Dubai, Al Jafiliya, Karama, Healthcare City, Al Jaddaf, Oud Metha, Deira, Al Nahda, Al Qusais, International City, Al Warqa, Mirdif, Al Rashidiya, Umm Ramool, Garhoud, Al Mizhar', prices: [290, 360, 440, 480, 590] },
      { id: 'dwc-z6', name: 'Zone 6', areas: 'Bab Al Shams, Al Maha Resort', prices: [380, 440, 530, 560, 700] },
      { id: 'dwc-z7', name: 'Zone 7', areas: 'Sharjah, Ajman, Umm Al Quwain, Abu Dhabi City, Al Ain City', prices: [450, 520, 600, 660, 750] },
      { id: 'dwc-z8', name: 'Zone 8', areas: 'Fujairah, Ras Al Khaimah, Khorfakkan', prices: [550, 630, 700, 760, 950] },
    ],
  },
  {
    id: 'AUH', name: 'Abu Dhabi International Airport (AUH)',
    zones: [
      { id: 'auh-z1', name: 'Zone 1', areas: 'Yas Island, Shahama, Shamkha, Masdar City', prices: [130, 150, 240, 260, 350] },
      { id: 'auh-z2', name: 'Zone 2', areas: 'Khalifa City A/B, Sas Al Nakheel, Mussafah, MBZ, AUH Golf Club, Al Raha', prices: [150, 170, 260, 280, 390] },
      { id: 'auh-z3', name: 'Zone 3', areas: 'ADNEC, Khalifa Park, Al Bateen Airport, Zayed Sports, Grand Mosque', prices: [160, 180, 270, 290, 400] },
      { id: 'auh-z4', name: 'Zone 4', areas: 'Corniche, Marina Mall, Emirates Palace, Louvre, Saadiyat Island', prices: [160, 180, 280, 300, 400] },
      { id: 'auh-z5', name: 'Zone 5', areas: 'Samha, Al Rahba, Al Bahyah, Al Dhafra Airbase', prices: [180, 200, 300, 330, 450] },
      { id: 'auh-z6', name: 'Zone 6', areas: 'Ghantoot', prices: [290, 310, 430, 450, 500] },
      { id: 'auh-z7', name: 'Zone 7', areas: 'Al Maktoum Airport, Jebel Ali', prices: [390, 400, 500, 550, 650] },
      { id: 'auh-z8', name: 'Zone 8', areas: 'Dubai Airport / City, Al Ain Airport / Al Ain City', prices: [440, 460, 600, 650, 750] },
      { id: 'auh-z9', name: 'Zone 9', areas: 'Sharjah / Sharjah Airport', prices: [490, 550, 730, 780, 950] },
      { id: 'auh-z10', name: 'Zone 10', areas: 'Ajman, Umm Al Quwain, Al Maha Resort', prices: [560, 640, 820, 850, 1050] },
      { id: 'auh-z11', name: 'Zone 11', areas: 'Ras Al Khaimah', prices: [750, 790, 940, 980, 1200] },
      { id: 'auh-z12', name: 'Zone 12', areas: 'Fujairah, Khorfakkan', prices: [790, 830, 990, 1050, 1350] },
      { id: 'auh-z13', name: 'Zone 13', areas: 'Ruwais, Liwa', prices: [850, 880, 1200, 1250, 1450] },
      { id: 'auh-z14', name: 'Zone 14', areas: 'Qasr Al Sarab, Sir Bani Yas, Jebel Dhanna', prices: [980, 1050, 1350, 1400, 1650] },
    ],
  },
];

// AED parking & coordination fee applied on airport arrival pickups (App IV note).
export const AIRPORT_ARRIVAL_FEE = 40;

// ─────────────────────────── CITY POINT-TO-POINT (App V, EuroGulf Limousine) ───────────────────────────
export const CITY_LOCATIONS = [
  'DXB Airport', 'Deira', 'Al Qusais', 'Bur Dubai', 'Downtown', 'Al Barsha', 'Dubai Internet City',
  'Dubai Marina', 'Palm Jumeirah', 'Sports City', 'International City', 'Jebel Ali', 'DIP / Expo City',
  'DWC Airport', 'Abu Dhabi', 'Fujairah / RAK', 'Sharjah', 'Ajman',
];

// Base rate is Audi A6 (Premium Sedan). Rows keyed by origin index; 18 columns per row.
const CITY_MATRIX = {
  0: [0, 140, 140, 140, 170, 190, 190, 220, 220, 220, 220, 260, 260, 260, 450, 450, 290, 290],
  1: [140, 100, 110, 115, 120, 140, 140, 150, 165, 165, 160, 180, 180, 180, 390, 420, 170, 200],
  2: [140, 110, 100, 115, 120, 140, 140, 160, 175, 170, 150, 170, 190, 200, 390, 420, 170, 200],
  3: [140, 115, 115, 100, 100, 125, 130, 140, 165, 165, 155, 170, 180, 190, 390, 420, 170, 200],
  4: [170, 120, 120, 100, 100, 115, 115, 125, 150, 155, 150, 160, 180, 190, 390, 420, 180, 200],
  5: [190, 140, 140, 125, 115, 100, 105, 125, 150, 155, 150, 150, 170, 170, 390, 420, 180, 200],
  6: [190, 140, 140, 130, 115, 105, 100, 125, 150, 155, 150, 150, 170, 170, 390, 420, 185, 220],
  7: [220, 150, 160, 140, 125, 125, 125, 100, 120, 155, 155, 150, 170, 170, 380, 440, 200, 260],
  8: [220, 165, 175, 165, 150, 150, 150, 120, 90, 165, 160, 140, 165, 165, 400, 460, 230, 260],
  9: [220, 165, 170, 165, 155, 155, 155, 155, 165, 130, 145, 145, 165, 160, 400, 460, 230, 260],
  10: [220, 160, 150, 155, 150, 150, 150, 155, 160, 145, 130, 140, 165, 170, 400, 460, 230, 260],
  11: [260, 170, 170, 170, 160, 150, 150, 150, 140, 140, 140, 150, 150, 165, 370, 470, 250, 280],
  12: [260, 180, 190, 180, 180, 170, 170, 170, 165, 165, 165, 150, 120, 165, 370, 470, 250, 280],
  13: [260, 180, 200, 190, 190, 170, 170, 170, 165, 160, 170, 165, 165, 120, 370, 470, 250, 280],
};

// Vehicle supplements on top of the Audi A6 base (App V).
export const CITY_VEHICLES = [
  { id: 'premium-sedan', name: 'Premium Sedan', models: 'Audi A6', pax: '3 passengers · 2 bags', supp: 0 },
  { id: 'first-sedan', name: 'First Class Sedan', models: 'BMW 7 Series / S-Class', pax: '3 passengers · 2 bags', supp: 210, badge: 'VIP' },
  { id: 'exec-van', name: 'Executive Van', models: 'Mercedes Viano', pax: '7 passengers · 7 bags', supp: 140 },
  { id: 'large-suv', name: 'Large SUV', models: 'Chevrolet Suburban', pax: '6 passengers · 5 bags', supp: 120 },
];

// Audi A6 base rate between two city locations (symmetric fallback). null if not tariffed.
export const cityBaseRate = (fromIdx, toIdx) => {
  if (fromIdx === toIdx) return 0;
  if (CITY_MATRIX[fromIdx] && CITY_MATRIX[fromIdx][toIdx] != null) return CITY_MATRIX[fromIdx][toIdx];
  if (CITY_MATRIX[toIdx] && CITY_MATRIX[toIdx][fromIdx] != null) return CITY_MATRIX[toIdx][fromIdx];
  return null;
};

// ─────────────────────────── BUS HIRE & TRANSFERS (App I) ───────────────────────────
// Columns order for every bus price array.
export const BUS_TYPES = [
  { id: 'hiace', name: 'Toyota Hiace', seats: 12 },
  { id: 'sprinter', name: 'Mercedes Sprinter', seats: 20 },
  { id: 'coaster', name: 'Toyota Coaster', seats: 22 },
  { id: 'higer34', name: 'Higer Coach', seats: 34 },
  { id: 'higer50', name: 'Higer Coach', seats: 50 },
  { id: 'scania', name: 'Scania Coach', seats: 47 },
];

export const BUS_AIRPORT_DEST = [
  { name: 'Deira, Festival City, Al Qusais, Mirdif', prices: [220, 700, 330, 530, 690, 780], hrs: '1 hr' },
  { name: 'Bur Dubai, Karama, Healthcare City, Dubai Frame, Garden Glow, Dubai Museum', prices: [230, 725, 350, 550, 710, 800], hrs: '1 hr' },
  { name: 'Downtown, Business Bay, Jumeirah 1 & 2, La Mer, City Walk, Design District, Meydan, Nad Al Sheba', prices: [250, 750, 370, 560, 730, 820], hrs: '1 hr' },
  { name: 'Jumeirah 3, Mall of the Emirates', prices: [280, 780, 380, 580, 750, 840], hrs: '1 hr' },
  { name: 'Dubai Marina / JLT, Emirates Golf Club, Bluewaters Island', prices: [300, 810, 390, 620, 790, 880], hrs: '1 hr' },
  { name: 'Sports City, Motor City, Jumeirah Golf Estates, Global Village, Miracle & Butterfly Garden', prices: [320, 880, 410, 640, 810, 900], hrs: '1.5 hrs' },
  { name: 'Palm Jumeirah / Expo City / Jebel Ali', prices: [330, 890, 430, 660, 830, 920], hrs: '1.5 hrs' },
  { name: 'DWC Airport / Dubai Parks & Resorts', prices: [340, 900, 440, 720, 890, 980], hrs: '1.5 hrs' },
  { name: 'Sharjah, Ajman, Bab Al Shams, Al Maha Resort', prices: [360, 940, 480, 780, 960, 1050], hrs: '2 hrs' },
  { name: 'Umm Al Quwain', prices: [440, 1050, 530, 830, 1070, 1160], hrs: '2 hrs' },
  { name: 'Abu Dhabi', prices: [460, 1200, 580, 940, 1170, 1260], hrs: '2 hrs' },
  { name: 'Fujairah, Ras Al Khaimah, Khorfakkan', prices: [480, 1250, 630, 980, 1270, 1360], hrs: '3 hrs' },
];

export const BUS_HALFDAY = [
  { name: 'Dubai City Tour (6 hrs)', prices: [620, 1550, 740, 1060, 1240, 1340] },
  { name: 'Dubai to Sharjah City (6 hrs)', prices: [720, 1750, 980, 1160, 1360, 1560] },
];

export const BUS_FULLDAY = [
  { name: 'Dubai — various (12 hrs)', prices: [800, 2200, 1000, 1340, 1800, 2000] },
  { name: 'Abu Dhabi / Al Ain / RAK / Fujairah / UAQ / Khorfakkan (12 hrs)', prices: [920, 2450, 1200, 1440, 2000, 2240] },
];

export const BUS_EXCESS_HOUR = [90, 250, 100, 130, 140, 160];

// ─────────────────────────── TERMS & CONDITIONS ───────────────────────────
export const TRANSFER_TERMS = [
  'Rates are in AED, net & non-commissionable, and include fuel, Salik road tolls, Dubai airport car-park fee and full insurance.',
  'All reservations should be made a minimum of 12 hours in advance.',
  'For airport pickups (Terminals 1, 2 & 3), guests should contact the Europcar Airport Counter for meet & greet.',
  'Pickup / drop-off from Airport Terminal 2 carries an additional AED 50.',
  'Maximum waiting time for departure transfers is 15 minutes; beyond this the booking is treated as a No-Show and charged in full.',
  'No-Show and cancellations less than 6 hours before pickup are charged in full as per tariff.',
  'Full-day rate includes 400 free km per day; additional km charged at AED 1/km.',
  'A parking & coordination fee of AED 40 applies to all airport arrival transfers.',
  '5% VAT applies to all charges.',
];

export const BUS_TERMS = [
  'Rates are in AED, net & non-commissionable, and include Salik road tolls, full insurance and fuel cost.',
  'All reservations require a minimum of 72 hours advance notice.',
  'Arrival parking fee is charged as actual — AED 250 + VAT per arrival (AED 150 for 12-seat buses).',
  'Transfers to Sharjah, Ajman, Ras Al Khaimah & Fujairah require an RTA permit of the respective emirate, chargeable at AED 250.',
  'Dubai Airport car-park surcharge on arrival: AED 250 for 50/34/22-seat buses, AED 150 for 12-seat buses. Abu Dhabi Airport: AED 50/hr for all buses.',
  'Arrival airport grace period is limited to 45 minutes; excess time is charged accordingly.',
  'Maximum free km for 12-hour hire is 300 km within Dubai and 400 km for other emirates; excess km charged at AED 3/km.',
  'Half-day rental (6 hours) applies within the city limits of Dubai and Sharjah only.',
  'Overnight-stay driver allowance is AED 400 per night.',
  'Rates do not apply on blackout dates (e.g. Dubai Airshow, Abu Dhabi F1, Dubai World Cup).',
  'Cancellation 24+ hours before reservation is free of charge; 12–24 hours before is charged 50%.',
  '5% VAT applies to all charges.',
];

export const RESERVATIONS_EMAIL = 'et_reservations@eurogulf.ae';
export const RESERVATIONS_PHONES = ['+971 56 509 4431', '+971 58 641 8001', '+971 4 506 3101'];
